var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('b-row', {
    staticClass: "mb-2"
  }, [_c('b-col', [_c('b-card', {
    staticClass: "bg-gradient-primary text-white"
  }, [_c('div', {
    staticClass: "d-flex align-items-center justify-content-between"
  }, [_c('div', {
    staticClass: "d-flex align-items-center"
  }, [_c('feather-icon', {
    staticClass: "mr-1",
    attrs: {
      "icon": "MapPinIcon",
      "size": "28"
    }
  }), _c('div', [_c('h2', {
    staticClass: "text-white mb-0"
  }, [_vm._v(_vm._s(_vm.isEdit ? 'Editar Endereço do Aluno' : 'Novo Endereço de Aluno'))]), _c('small', {
    staticClass: "text-white-50"
  }, [_vm._v("Cadastro de domicílio e dados de contato para visitas domiciliares de campo")])])], 1), _c('b-button', {
    attrs: {
      "variant": "outline-light",
      "size": "sm",
      "to": {
        name: 'AlunosEnderecosLista'
      }
    }
  }, [_c('feather-icon', {
    staticClass: "mr-50",
    attrs: {
      "icon": "ArrowLeftIcon"
    }
  }), _vm._v(" Voltar ")], 1)], 1)])], 1)], 1), _c('b-form', {
    on: {
      "submit": function submit($event) {
        $event.preventDefault();
        return _vm.salvar.apply(null, arguments);
      }
    }
  }, [_c('b-card', {
    staticClass: "mb-2"
  }, [_c('h5', {
    staticClass: "text-primary font-weight-bolder mb-1"
  }, [_c('feather-icon', {
    staticClass: "mr-50",
    attrs: {
      "icon": "UserIcon"
    }
  }), _vm._v(" Dados do Aluno e Contato ")], 1), _c('hr', {
    staticClass: "mb-2"
  }), _c('b-row', [_c('b-col', {
    attrs: {
      "md": "6"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "Nome Completo do Aluno *",
      "label-for": "nomeAluno"
    }
  }, [_c('b-form-input', {
    attrs: {
      "id": "nomeAluno",
      "placeholder": "Nome do aluno",
      "required": ""
    },
    model: {
      value: _vm.form.nomeAluno,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "nomeAluno", $$v);
      },
      expression: "form.nomeAluno"
    }
  })], 1)], 1), _c('b-col', {
    attrs: {
      "md": "6"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "Nome do Responsável",
      "label-for": "nomeResponsavel"
    }
  }, [_c('b-form-input', {
    attrs: {
      "id": "nomeResponsavel",
      "placeholder": "Pai, mãe ou responsável legal"
    },
    model: {
      value: _vm.form.nomeResponsavel,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "nomeResponsavel", $$v);
      },
      expression: "form.nomeResponsavel"
    }
  })], 1)], 1), _c('b-col', {
    attrs: {
      "md": "4"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "Telefone / WhatsApp",
      "label-for": "telefone"
    }
  }, [_c('b-form-input', {
    attrs: {
      "id": "telefone",
      "placeholder": "(81) 90000-0000"
    },
    model: {
      value: _vm.form.telefone,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "telefone", $$v);
      },
      expression: "form.telefone"
    }
  })], 1)], 1), _c('b-col', {
    attrs: {
      "md": "4"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "Escola",
      "label-for": "schoolId"
    }
  }, [_c('v-select', {
    attrs: {
      "id": "schoolId",
      "options": _vm.escolaOptions,
      "reduce": function reduce(option) {
        return option.value;
      },
      "label": "text",
      "placeholder": "Selecione a escola (opcional)"
    },
    on: {
      "input": _vm.onEscolaChange
    },
    model: {
      value: _vm.form.schoolId,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "schoolId", $$v);
      },
      expression: "form.schoolId"
    }
  })], 1)], 1), _c('b-col', {
    attrs: {
      "md": "4"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "Turma Cadastrada",
      "label-for": "classroomId"
    }
  }, [_c('v-select', {
    attrs: {
      "id": "classroomId",
      "options": _vm.turmaOptions,
      "reduce": function reduce(option) {
        return option.value;
      },
      "label": "text",
      "placeholder": "Selecione a turma",
      "disabled": !_vm.form.schoolId
    },
    model: {
      value: _vm.form.classroomId,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "classroomId", $$v);
      },
      expression: "form.classroomId"
    }
  })], 1)], 1), !_vm.form.classroomId ? _c('b-col', {
    attrs: {
      "md": "12"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "Ou digite a Turma / Ano (se não constar na lista)",
      "label-for": "turmaTexto"
    }
  }, [_c('b-form-input', {
    attrs: {
      "id": "turmaTexto",
      "placeholder": "Ex: 8º Ano B - Tarde"
    },
    model: {
      value: _vm.form.turmaTexto,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "turmaTexto", $$v);
      },
      expression: "form.turmaTexto"
    }
  })], 1)], 1) : _vm._e()], 1)], 1), _c('b-card', {
    staticClass: "mb-2"
  }, [_c('h5', {
    staticClass: "text-primary font-weight-bolder mb-1"
  }, [_c('feather-icon', {
    staticClass: "mr-50",
    attrs: {
      "icon": "HomeIcon"
    }
  }), _vm._v(" Endereço do Domicílio ")], 1), _c('hr', {
    staticClass: "mb-2"
  }), _c('b-row', [_c('b-col', {
    attrs: {
      "md": "4"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "Código do Domicílio",
      "label-for": "codigoDomicilio"
    }
  }, [_c('b-form-input', {
    attrs: {
      "id": "codigoDomicilio",
      "placeholder": "Ex: DOM-001 / Código da etiqueta"
    },
    model: {
      value: _vm.form.codigoDomicilio,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "codigoDomicilio", $$v);
      },
      expression: "form.codigoDomicilio"
    }
  })], 1)], 1), _c('b-col', {
    attrs: {
      "md": "4"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "CEP",
      "label-for": "cep"
    }
  }, [_c('b-input-group', [_c('b-form-input', {
    attrs: {
      "id": "cep",
      "placeholder": "00000-000"
    },
    on: {
      "blur": _vm.buscarCep
    },
    model: {
      value: _vm.form.cep,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "cep", $$v);
      },
      expression: "form.cep"
    }
  }), _c('b-input-group-append', [_c('b-button', {
    attrs: {
      "variant": "outline-primary",
      "disabled": _vm.isLoadingCep
    },
    on: {
      "click": _vm.buscarCep
    }
  }, [_vm.isLoadingCep ? _c('b-spinner', {
    attrs: {
      "small": ""
    }
  }) : _c('feather-icon', {
    attrs: {
      "icon": "SearchIcon"
    }
  })], 1)], 1)], 1)], 1)], 1), _c('b-col', {
    attrs: {
      "md": "4"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "Número",
      "label-for": "numero"
    }
  }, [_c('b-form-input', {
    attrs: {
      "id": "numero",
      "placeholder": "Nº da casa"
    },
    model: {
      value: _vm.form.numero,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "numero", $$v);
      },
      expression: "form.numero"
    }
  })], 1)], 1), _c('b-col', {
    attrs: {
      "md": "8"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "Logradouro / Endereço",
      "label-for": "endereco"
    }
  }, [_c('b-form-input', {
    attrs: {
      "id": "endereco",
      "placeholder": "Rua, Avenida, etc."
    },
    model: {
      value: _vm.form.endereco,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "endereco", $$v);
      },
      expression: "form.endereco"
    }
  })], 1)], 1), _c('b-col', {
    attrs: {
      "md": "4"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "Complemento",
      "label-for": "complemento"
    }
  }, [_c('b-form-input', {
    attrs: {
      "id": "complemento",
      "placeholder": "Apto, Bloco, etc."
    },
    model: {
      value: _vm.form.complemento,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "complemento", $$v);
      },
      expression: "form.complemento"
    }
  })], 1)], 1), _c('b-col', {
    attrs: {
      "md": "4"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "Bairro",
      "label-for": "bairro"
    }
  }, [_c('b-form-input', {
    attrs: {
      "id": "bairro",
      "placeholder": "Bairro"
    },
    model: {
      value: _vm.form.bairro,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "bairro", $$v);
      },
      expression: "form.bairro"
    }
  })], 1)], 1), _c('b-col', {
    attrs: {
      "md": "5"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "Município",
      "label-for": "municipio"
    }
  }, [_c('b-form-input', {
    attrs: {
      "id": "municipio",
      "placeholder": "Município"
    },
    model: {
      value: _vm.form.municipio,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "municipio", $$v);
      },
      expression: "form.municipio"
    }
  })], 1)], 1), _c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "Estado (UF)",
      "label-for": "estado"
    }
  }, [_c('b-form-input', {
    attrs: {
      "id": "estado",
      "placeholder": "UF (ex: PE)"
    },
    model: {
      value: _vm.form.estado,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "estado", $$v);
      },
      expression: "form.estado"
    }
  })], 1)], 1), _c('b-col', {
    attrs: {
      "md": "12"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "Ponto de Referência",
      "label-for": "pontoReferencia"
    }
  }, [_c('b-form-input', {
    attrs: {
      "id": "pontoReferencia",
      "placeholder": "Ex: Próximo à padaria São José / Em frente ao campinho"
    },
    model: {
      value: _vm.form.pontoReferencia,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "pontoReferencia", $$v);
      },
      expression: "form.pontoReferencia"
    }
  })], 1)], 1), _c('b-col', {
    attrs: {
      "md": "12"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "Observações Adicionais",
      "label-for": "observacoes"
    }
  }, [_c('b-form-textarea', {
    attrs: {
      "id": "observacoes",
      "placeholder": "Informações adicionais sobre o domicílio ou aluno...",
      "rows": "2"
    },
    model: {
      value: _vm.form.observacoes,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "observacoes", $$v);
      },
      expression: "form.observacoes"
    }
  })], 1)], 1)], 1)], 1), _c('div', {
    staticClass: "d-flex justify-content-end mb-4"
  }, [_c('b-button', {
    staticClass: "mr-1",
    attrs: {
      "variant": "outline-secondary",
      "to": {
        name: 'AlunosEnderecosLista'
      }
    }
  }, [_vm._v(" Cancelar ")]), _c('b-button', {
    attrs: {
      "variant": "primary",
      "type": "submit"
    }
  }, [_c('feather-icon', {
    staticClass: "mr-50",
    attrs: {
      "icon": "SaveIcon"
    }
  }), _vm._v(" " + _vm._s(_vm.isEdit ? 'Salvar Alterações' : 'Cadastrar Endereço') + " ")], 1)], 1)], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }